// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1GCmb","form":"styles_form__28NFs"};